var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfileIc02(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 74.001,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "6ym8u2xo2a"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "\\uD0C0\\uC6D0 952",
    cx: 37,
    cy: 37,
    r: 37,
    transform: "translate(2 6.001)",
    style: {
      fill: "#e6e6e6"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-116.561 -9063.318)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "\\uD0C0\\uC6D0 948",
    cx: 37,
    cy: 37,
    r: 37,
    transform: "translate(116.561 9063.318)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uB9C8\\uC2A4\\uD06C \\uADF8\\uB8F9 16",
    transform: "translate(114.56 9057.318)",
    style: {
      clipPath: "url(#6ym8u2xo2a)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 13392",
    transform: "translate(11.204 15.281)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "\\uD0C0\\uC6D0 941",
    cx: 12.845,
    cy: 12.845,
    r: 12.845,
    transform: "translate(15.415 10)",
    style: {
      fill: "#c9c9c9"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "\\uD0C0\\uC6D0 951",
    cx: 28.26,
    cy: 20.553,
    rx: 28.26,
    ry: 20.553,
    transform: "translate(0 41.005)",
    style: {
      fill: "#c9c9c9"
    }
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIc02);
export default __webpack_public_path__ + "static/media/profile_ic-02.35165fd736b4814dd672ea7a6085f6a0.svg";
export { ForwardRef as ReactComponent };